module.exports = __webpack_public_path__ + "static/img/lost-ethereal-pixel-art-low-res-retro-8bit-bridges.6fa8fcb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/lost-ethereal/lost-ethereal-pixel-art-low-res-retro-8bit-bridges.gif
// module id = EFXr
// module chunks = 0